<template>
  <div>
    <b-button id="switch-btn" variant="info" class="mb-3" @click="switchView"
      >問いを追加</b-button
    >

    <b-card bg-variant="light" class="m-3 question-post" v-if="view">
      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-default">タイトル:</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea
            id="textarea-default"
            rows="3"
            placeholder="タイトルを入力してください。"
            v-model="question"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-default">内容:</label>
        </b-col>
        <b-col sm="10">
          <b-form-textarea
            id="textarea-default"
            rows="10"
            placeholder="内容を入力してください。"
            v-model="answer"
          ></b-form-textarea>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col sm="2">
          <label for="textarea-default">ページ:</label>
        </b-col>
        <b-col sm="4">
          <b-form-input v-model="page" type="number"></b-form-input>
        </b-col>
        <b-col sm="2">
          <label for="textarea-default">行:</label>
        </b-col>
        <b-col sm="4">
          <b-form-input v-model="line" type="number"></b-form-input>
        </b-col>
      </b-row>
      <b-button variant="info" class="mt-4" v-on:click="saveQuestion"
        >投稿</b-button
      >
    </b-card>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/firebase";
export default {
  props: ["bookId", "bookImage"],
  data: function() {
    return {
      view: false,
      question: "",
      answer: "",
      page: null,
      line: null
    };
  },
  methods: {
    saveQuestion() {
      // 問いコレクションに問い情報を格納
      db.collection("questions")
        .add({
          text: this.question,
          answer: this.answer,
          user: this.$store.getters.user.id,
          book: this.bookId,
          bookImage: this.bookImage,
          favCount: 0,
          page: this.page,
          line: this.line,
          createdAt: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(docRef => {
          // ユーザーコレクションに問いIDを格納
          const questions = this.$store.getters.user.questions;
          questions.push(docRef.id);
          this.$store.dispatch("updateUserData", { questions: questions });
          // 本コレクションに問いIDを格納
          const bookRef = db.collection("books").doc(this.bookId);
          return db
            .runTransaction(transaction => {
              return transaction.get(bookRef).then(doc => {
                console.log("in transaction ", doc.data());
                if (!doc.data().questions) {
                  transaction.set(
                    bookRef,
                    {
                      questions: [docRef.id]
                    },
                    { merge: true }
                  );
                } else {
                  const questions = doc.data().questions;
                  console.log("questions ", questions);
                  questions.push(docRef.id);
                  transaction.update(bookRef, { questions: questions });
                }
              });
            })
            .then(function() {
              console.log("Transaction successfully committed!");
              document.location.reload();
            })
            .catch(function(error) {
              console.log("Transaction failed: ", error);
            });
        });
    },

    switchView() {
      const switchBtn = document.getElementById("switch-btn");
      if (this.view) {
        this.view = false;
        switchBtn.textContent = "問いを追加";
      } else {
        this.view = true;
        switchBtn.textContent = "閉じる";
      }
    }
  }
};
</script>

<style lang="scss">
.question-box {
  width: 60%;
  margin: 10px auto;
  display: flex;
  flex-direction: column;
}
</style>
